import { Attr, Model } from "spraypaint";
import ApplicationRecord from "./ApplicationRecord";

@Model()
class YearlyHhTimeToHire extends ApplicationRecord {
  static jsonapiType = "yearly_hh_time_to_hires";

  @Attr() lastTwelveMonths: number;

  @Attr() lastTwelveMonthsMonthly: Record<string, number>;

  @Attr() lastNinetyDaysWeekly: Record<string, number>;

  @Attr() lastThirtyDaysWeekly: Record<string, number>;
}

export default YearlyHhTimeToHire;
